import * as constants from './constants'
import { fetchAsJson } from '@eig-builder/core-utils/helpers/fetch-helper'
import { getUrl, siteNames } from '@eig-builder/core-utils/helpers/url-helper'

export const loadDomainsByAccount = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/domain'), {
    key: constants.GET_DOMAINS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}
export const loadRegisteredDomainsByAccount = (accountId, partnerId, pageIndex, PageSize) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/domain/RegisterDomain/${pageIndex}/${PageSize}`), {
    key: constants.GET_REGISTERED_DOMAINS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const loadLinkedDomainsByAccount = (accountId, partnerId, pageIndex, PageSize) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, `/v1.0/domain/LinkedDomain/${pageIndex}/${PageSize}`), {
    key: constants.GET_LINKED_DOMAINS_BY_ACCOUNT,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}
